import { useCallback, useEffect, useRef } from 'react';

/// A step unmounts as soon as its call succeeds (the flow moves on), so post-await state
/// updates have to be guarded or React warns about updating an unmounted component.
export const useIsMounted = () => {
    const mounted = useRef(true);

    useEffect(() => () => { mounted.current = false; }, []);

    return useCallback(() => mounted.current, []);
}
